import { render } from "./BaseSelector.vue?vue&type=template&id=2c2d3aba&scoped=true"
import script from "./BaseSelector.vue?vue&type=script&lang=js"
export * from "./BaseSelector.vue?vue&type=script&lang=js"

import "./BaseSelector.vue?vue&type=style&index=0&id=2c2d3aba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2d3aba"]])

export default __exports__